import React from 'react';

const WorkspaceIcon = (className: any) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.72075 1.88752H5.94396C5.60455 1.88752 5.33014 2.16207 5.33014 2.50164V13.5053C5.33014 13.8448 5.60455 14.1194 5.94396 14.1194H9.72075C10.0602 14.1194 10.3346 13.8448 10.3346 13.5053V2.50164C10.3346 2.16207 10.0602 1.88752 9.72075 1.88752ZM10.3346 0.666504C11.0134 0.666504 11.555 1.2156 11.555 1.88752V14.1122C11.555 14.7913 11.0062 15.3332 10.3346 15.3332H5.33736C4.66577 15.3332 4.11695 14.7841 4.11695 14.1122V1.88752C4.11695 1.2156 4.66577 0.666504 5.33736 0.666504H10.3346Z'
    />

    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9453 2.50164H12.0966V3.72266H13.3315C13.6709 3.72266 13.9453 3.99721 13.9453 4.33678V11.7279C13.9453 12.0675 13.6709 12.342 13.3315 12.342H12.0966V13.5631H13.9453C14.6241 13.5631 15.1657 13.014 15.1657 12.342V3.72989C15.1657 3.05797 14.6169 2.50887 13.9453 2.50887V2.50164Z'
    />

    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.71944 13.5631H3.56812V12.342H2.33326C1.99385 12.342 1.71944 12.0675 1.71944 11.7279V4.33678C1.71944 3.99721 1.99385 3.72266 2.33326 3.72266H3.56812V2.50164H1.71944C1.04063 2.50164 0.499023 3.05074 0.499023 3.72266V12.3348C0.499023 13.0067 1.04785 13.5558 1.71944 13.5558V13.5631Z'
    />
  </svg>
);

export default WorkspaceIcon;
